import type { SuitableProductProps } from '@hub/common/SuitableProduct/SuitableProduct';
import { SuitableProduct } from '@hub/common/SuitableProduct/SuitableProduct';
import type { TechnicalData } from '@hub/models/data';
import type { ProductFragmentAttributes } from '@hub/bearing-hub/ProductDetails/AkeneoProductData/attribute.helper';

export type TechnicalDataCategory = {
  name?: string | null | undefined;
  label?: string | null | undefined;
  attributes: TechnicalData[];
};

export type TechnicalDataQueryResult = {
  categories: TechnicalDataCategory[];
  chemicalAttributeNames: string[];
  technicalProductAttributes: ProductFragmentAttributes;
};

type SuitableProductsProps = {
  suitableProducts: SuitableProductProps[];
};

export const SuitableProductsTab = ({ suitableProducts }: SuitableProductsProps) => (
  <div className="text-sm pt-0 lg:pt-8 lg:mr-8">
    {suitableProducts.map(suitableProduct => (
      <SuitableProduct
        key={`suitableProduct-${suitableProduct.productIdDisplayName || ''}`}
        title={suitableProduct.title}
        slug={suitableProduct.slug}
        usp={suitableProduct.usp}
        new={suitableProduct.new}
        image={suitableProduct.image}
        priceType={suitableProduct.priceType}
        prices={suitableProduct.prices}
        deliveryTimes={suitableProduct.deliveryTimes}
        productIdDisplayName={suitableProduct.productIdDisplayName}
        legacyLinkTarget={suitableProduct.legacyLinkTarget}
      />
    ))}
  </div>
);
